import { SearchTips } from "./SearchTips";
export default SearchTips;
